var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:{ active: _vm.active }},[_vm._v(" "+_vm._s(_vm.$tc('active_inactive', _vm.active))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }